import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.join.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c4531198"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "view-wrapper"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "text"
};
var _hoisted_4 = {
  class: "info"
};
var _hoisted_5 = {
  class: "info"
};
var _hoisted_6 = {
  class: "retry-container"
};
import { onMounted, onBeforeUnmount, ref, computed } from "vue";
import { preventAppRefresh, allowAppRefresh } from "@/utils/vue-helpers/log";
import { LogService } from "@/services/logging";
import { BelgiumComplianceErrorCodes, initializeComplianceLib, testFdmConnection } from "@/utils/helpers/compliance";
import ComplianceModule from "@/store/modules/compliance";
import { LocalStorageKeys } from "@/services/storage.service";
import DeviceModule from "@/store/modules/device";
export default /*#__PURE__*/_defineComponent({
  __name: 'SellingDisabled',
  setup: function setup(__props) {
    var refreshingComplianceStatus = ref(false);
    var hardwareUid = computed(function () {
      var _DeviceModule$hardwar;

      return DeviceModule.getHardwareHash || localStorage.getItem(LocalStorageKeys.manualHardwareUuid) || ((_DeviceModule$hardwar = DeviceModule.hardwareInfo) === null || _DeviceModule$hardwar === void 0 ? void 0 : _DeviceModule$hardwar.id) || "Unknown";
    });
    var errorCodes = computed(function () {
      var _DeviceModule$hardwar2;

      var codes = [];
      var _ComplianceModule$bel = ComplianceModule.belgiumComplianceStatus,
          packageInit = _ComplianceModule$bel.packageInit,
          fdmConnection = _ComplianceModule$bel.fdmConnection;

      if (!packageInit) {
        codes.push(BelgiumComplianceErrorCodes.COMPLIANCE_LIB_INIT_FAILED);
      }

      if (!fdmConnection) {
        codes.push(BelgiumComplianceErrorCodes.FDM_NOT_CONNECTED);
      }

      if (!((_DeviceModule$hardwar2 = DeviceModule.hardwareLocation) !== null && _DeviceModule$hardwar2 !== void 0 && _DeviceModule$hardwar2.deviceUid)) {
        codes.push(BelgiumComplianceErrorCodes.DEVICE_NOT_ASSIGNED);
      }

      if (!codes.length) {
        codes.push(BelgiumComplianceErrorCodes.UNKNWON_ERROR);
      }

      return codes.join(", ");
    });
    onMounted(function () {
      // allow aborting recovery after 90 seconds
      LogService.info("Disabled sales view mounted", {
        errorCodes: errorCodes
      });
      preventAppRefresh();
    });
    onBeforeUnmount(function () {
      LogService.info("Disabled sales view unmounted");
      allowAppRefresh();
    });

    function refreshComplianceStatus() {
      return _refreshComplianceStatus.apply(this, arguments);
    }

    function _refreshComplianceStatus() {
      _refreshComplianceStatus = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ComplianceModule$bel2, packageInit, fdmConnection;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                refreshingComplianceStatus.value = true;
                _ComplianceModule$bel2 = ComplianceModule.belgiumComplianceStatus, packageInit = _ComplianceModule$bel2.packageInit, fdmConnection = _ComplianceModule$bel2.fdmConnection;

                if (packageInit) {
                  _context.next = 11;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return initializeComplianceLib();

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](3);
                LogService.info("Failed to initialize compliance lib", {
                  error: _context.t0
                });

              case 11:
                if (fdmConnection) {
                  _context.next = 14;
                  break;
                }

                _context.next = 14;
                return testFdmConnection();

              case 14:
                refreshingComplianceStatus.value = false;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 8]]);
      }));
      return _refreshComplianceStatus.apply(this, arguments);
    }

    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("compliance.sales-disabled")), 1), _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("compliance.sales-disabled-content-belgium")), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("compliance.error-codes")) + ": " + _toDisplayString(errorCodes.value), 1), _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("complaince.hardware-uid")) + ": " + _toDisplayString(hardwareUid.value), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: refreshComplianceStatus,
        loading: refreshingComplianceStatus.value
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("label.refresh")), 1)];
        }),
        _: 1
      }, 8, ["loading"])])]);
    };
  }
});